// Centralised TanStack Query keys — one source of truth so invalidation is
// predictable.

export const qk = {
  me: ["me"] as const,
  tenants: ["tenants"] as const,
  tenant: (slug: string) => ["tenants", slug] as const,
  platformModels: (kind: string) => ["platform-models", kind] as const,
  trustedSystems: ["trusted-systems"] as const,
  members: ["my", "users"] as const,
  storeAgents: ["chat", "agents"] as const,
  observability: ["my", "observability"] as const,
  evaluationSettings: ["my", "evaluation-settings"] as const,
  chatConversations: ["chat", "conversations"] as const,
  chatConversation: (id: string) => ["chat", "conversations", id] as const,
  orgConversations: (userEmail: string) => ["chat", "org", userEmail] as const,
  orgConversation: (id: string) => ["chat", "org", "detail", id] as const,
  myTenant: ["my", "tenant"] as const,
  kbAwsOnboarding: ["my", "kb-aws-onboarding"] as const,
  myDomains: ["my", "domains"] as const,
  myAgents: ["my", "agents"] as const,
  agent: (slug: string) => ["my", "agents", slug] as const,
  semanticCache: (slug: string) => ["my", "agents", slug, "semantic-cache"] as const,
  versions: (slug: string) => ["my", "agents", slug, "versions"] as const,
  version: (slug: string, label: string) => ["my", "agents", slug, "versions", label] as const,
  live: (slug: string) => ["my", "agents", slug, "live"] as const,
  versionDiff: (slug: string, label: string) =>
    ["my", "agents", slug, "versions", label, "diff"] as const,
  versionLlm: (slug: string, label: string) =>
    ["my", "agents", slug, "versions", label, "llm"] as const,
  skills: (slug: string, label: string) =>
    ["my", "agents", slug, "versions", label, "skills"] as const,
  capabilities: ["my", "capabilities"] as const,
  attached: (slug: string, label: string) =>
    ["my", "agents", slug, "versions", label, "capabilities"] as const,
  validatorCatalog: ["my", "validators"] as const,
  attachedValidators: (slug: string, label: string) =>
    ["my", "agents", slug, "versions", label, "validators"] as const,
  knowledgeBases: ["my", "knowledge-bases"] as const,
  knowledgeBase: (slug: string) => ["my", "knowledge-bases", slug] as const,
  attachedKbs: (slug: string, label: string) =>
    ["my", "agents", slug, "versions", label, "knowledge-bases"] as const,
  // Agent-config governance (ADR-016)
  modelCatalog: ["my", "model-catalog"] as const,
  llmModels: ["my", "llm-models"] as const,
  embeddingModels: ["my", "embedding-models"] as const,
  vectorStores: ["my", "vector-stores"] as const,
  githubInstallation: ["my", "github", "installation"] as const,
  governedRepos: ["my", "github", "repos"] as const,
  governedFiles: (repoId: number) => ["my", "github", "repos", repoId, "files"] as const,
  governedFile: (repoId: number, fileId: number) =>
    ["my", "github", "repos", repoId, "files", fileId] as const,
  prReviews: (filters: Record<string, unknown> = {}) =>
    ["my", "governance", "reviews", filters] as const,
  prReview: (reviewId: number) => ["my", "governance", "reviews", reviewId] as const,
  governanceActivity: (filters: Record<string, unknown> = {}) =>
    ["my", "governance", "activity", filters] as const,
  governanceSettings: ["my", "governance", "settings"] as const,
  governanceSummary: ["my", "governance", "summary"] as const,
  repoChecks: ["my", "governance", "checks"] as const,
  securityFindings: (filters: Record<string, unknown> = {}) =>
    ["my", "governance", "security", "findings", filters] as const,
  repoScans: (filters: Record<string, unknown> = {}) =>
    ["my", "governance", "security", "scans", filters] as const,
  securitySummary: ["my", "governance", "security", "summary"] as const,
  securityAiReview: ["my", "governance", "security", "ai-review"] as const,
};
